<template>
<div v-if="showComponent" >
  <h4>{{title}}</h4>
  <font-awesome-icon
    id="font-awesome-icon-edit"
    icon="edit"
    size="sm"
    class="clickable float-right mt-1"
    v-if="showEditButton"
    @click="$emit('edit-button-clicked')"
  />
  <lm-dropdown
    v-if="isEditableByPickedUser"
    class="float-right"
    :tooltip="!disableEditors ? 'Selecciona quién edita este campo' : null"
    template="user-list"
    @input="$emit('editor-change', $event)"
    :value="collaborator"
    :disabled="disableEditors"
    closeAfterPick
  >
    <div class="d-flex align-items-center gap-2">
      {{ collaborator.name || '' }}
      <a-icon type="edit" v-if="!disableEditors" />
    </div>
  </lm-dropdown>
  <template v-if="type === 'single'">
    <label  class="d-block">{{ subtitle }} <small v-if="isRequired">*</small></label>
    <div class="clearfix d-inline-block" >
    <label :for="id + _uid" :style="size==='sm'? 'font-size:13px' : '' || size==='lg'? 'font-size:19px' : '' " :class="labelPosition === 'right' ? 'mr-2': ''" v-text="labelSingle ? labelSingle : status" class="checkbox_label"></label>
    <b-form-checkbox
      :id="id + _uid"
      v-model="selected"
      :value="checkValue"
      :unchecked-value="uncheckedValue"
      :class="labelPosition === 'right' ? 'float-right': 'float-left'"
      :size='size'
      :switch="variant === 'switch' ? 'switch' : false"
      @input="$emit('input', $event)"
      :state="validation.hasError ? false : undefined"
      :disabled="disabled"
    />
    </div>
  </template>

  <template v-if="type === 'multiple'">
    <label class="d-block">{{ subtitle }} <small v-if="isRequired">*</small></label>
    <b-form-group>
      <b-form-checkbox-group
        :id="id + _uid"
        v-model="selected"
        :options="options"
        :size='size'
        :stacked="orientation === 'stacked'"
        :switches="variant === 'switch' ? 'switches' : false"
        @input="$emit('input', $event)"
        :state="validation.hasError ? false : undefined"
      >
      </b-form-checkbox-group>
    </b-form-group>
  </template>
  <p class="invalid-feedback" v-if="validation.hasError"> {{ showValidationErrorMessage }} </p>
</div>
</template>

<script>
// Utils
import LmCommonProps from '@/mixins/LmCommonProps'

export default {
  mixins: [LmCommonProps],
  data () {
    return {
      selected: null
    }
  },
  props: {
    checkValue: {
      type: [Boolean, String],
      default: true
    },
    uncheckedValue: {
      type: [Boolean, String],
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    labelSingle: {
      type: String,
      default: 'Label single'
    },
    labelPosition: {
      type: String,
      default: 'left'
    },
    type: {
      type: String,
      default: 'single'
    },
    size: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      default: ''
    },
    orientation: {
      type: String,
      default: 'inline'
    },
    options: {
      type: Array,
      default: () => []
    },
    showEditButton: {
      type: Boolean,
      default: false
    },
    isVisible: {
      type: Boolean,
      default: true
    },
    singleSelected: {
      type: Boolean,
      default: false
    },
    invalidText: {
      type: String
    },
    validText: {
      type: String
    }
  },
  watch: {
    value: {
      handler (val) {
        const value = val === '' ? false : val
        this.selected = value
      }
    }
  },
  created () {
    const value = this.value === '' ? false : this.value
    this.selected = value
  }
}
</script>

<style lang="sass" scoped>
.checkbox_label
  padding-top: 3px
</style>
